import { createAction, props } from "@ngrx/store";
import { AccountDetailInterface } from "src/app/common/services/api/account/type/account-detail.type";

export const resolveAssociatedProjects = createAction(
  'Account.ResolveAssociatedProjects',
  props<{
    projects: AccountDetailInterface[];
  }>()
);
